
import Vue, { PropType } from 'vue'
import { User } from '@/model/User'

export default Vue.extend({
  name: 'Emblem',
  props: {
    user: {
      type: Object as PropType<User>,
    },
  },
  data: () => ({}),
})
